import { FirebaseOptions } from "@firebase/app";

import { isProduction } from "helpers/environment";

const apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY as string;

const getFirebaseConfig = (): FirebaseOptions => {
  if (isProduction) {
    return {
      apiKey,
      authDomain: "anabelrose-f85be.firebaseapp.com",
      projectId: "anabelrose-f85be",
      storageBucket: "anabelrose-f85be.firebasestorage.app",
      messagingSenderId: "801240677371",
      appId: "1:801240677371:web:b766be3e2948d52933295e",
      measurementId: "G-PD2ZJK8QTW",
    };
  }

  return {
    apiKey,
    authDomain: "anabelrose-f85be.firebaseapp.com",
    projectId: "anabelrose-f85be",
    storageBucket: "anabelrose-f85be.firebasestorage.app",
    messagingSenderId: "801240677371",
    appId: "1:801240677371:web:b766be3e2948d52933295e",
    measurementId: "G-PD2ZJK8QTW",
  };
};

const firebaseConfig = getFirebaseConfig();
export default firebaseConfig;
